import { Block } from 'baseui/block';
import { Notification, KIND as NotificationKIND } from 'baseui/notification';
import { HeadingMedium } from 'baseui/typography';
import { useRouteError } from 'react-router-dom';

function ErrorPage() {
    const error: any = useRouteError();
    return (
        <Block display={'flex'} flexDirection={'column'} alignItems='center' >
        <HeadingMedium>Sorry, an unexpected error has occurred.</HeadingMedium>
            <Notification kind={NotificationKIND.negative}>
                {error.statusText || error.message}
            </Notification>
        </Block>
    )
}

export default ErrorPage